import { styled } from "@linaria/react";
import { color } from "../../index";
import { fonts } from "../../Theme";
export const HIGHCHARTS_MARKERS_HIDDEN = "highcharts-marker-hidden";
export const FIT_WRAPPER_HEIGHT = "fit-wrapper-height";
export const GROUP_LABEL_CLASS = "cycle-label";
export const GROUP_PLOTLINE_COLOR = color.titanium100;

export const PlotlineLabelZIndex = {
  default: 0,
  analysis: 1,
  cycleHover: 2,
};

const Wrapper = styled.div`
  position: relative;
  flex: 1;
  height: 100%;

  .highcharts-container.${HIGHCHARTS_MARKERS_HIDDEN} .highcharts-series-group .highcharts-point {
    display: none;
  }

  .highcharts-container,
  .highcharts-container svg {
    will-change: width, height;
  }

  &.${FIT_WRAPPER_HEIGHT} {
    .highcharts-container {
      position: absolute !important;
    }
  }

  /* firefox print hacks */
  @media print {
    /* https://stackoverflow.com/a/32455002 */
    @supports (-moz-appearance: none) {
      /* since charts cannot be resized on print, we scale them */
      .highcharts-root,
      .highcharts-container {
        width: 100% !important;
        height: 100% !important;
      }

      /* HTML elements aren't resized when the graph is scaled */
      .highcharts-plot-line-label {
        display: none;
      }
    }
  }

  .highcharts-container {
    z-index: initial !important;
    user-select: none;

    .highcharts-background {
      display: none;
    }
  }
  .highcharts-axis-title {
    text-align: center;
  }
  .highcharts-reset-zoom {
    display: none;
  }
  /* Highlights all points, no control... */
  .highcharts-halo.highcharts-color-undefined {
    display: none;
  }

  /* Legend markers are vertical*/
  .highcharts-legend-item.highcharts-line-series {
    transition: opacity 400ms ease-in-out;
    .highcharts-graph {
      transform: translate(0px, 0px);
    }
    path.highcharts-point {
      display: none;
    }
  }
  .flag-legend-container {
    display: flex;
  }
  .flag-legend-symbol-x {
    padding: 0 5px;
  }
  .flag-legend-symbol-x-NoModelOutput {
    color: ${color.chlorine600};
  }
  .flag-legend-symbol-x-NoValue {
    color: ${color.oxygen400};
  }

  .flag-legend-symbol-not-visible {
    border-color: ${color.titanium300};
    opacity: 0.2;
  }
  .forced-valid-symbol {
    margin-left: 20px;
    height: 10px;
    width: 10px;
    background-color: ${color.lightNitrogen500_Main};
    border-radius: 50%;
    display: inline-block;
  }
  .forced-valid-symbol-hide {
    background-color: ${color.titanium300};
  }

  .${GROUP_LABEL_CLASS} {
    color: ${color.carbon600};
    font: ${fonts.body2};
    height: 23px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    &:not(.startBefore) {
      border-left: 2px solid ${GROUP_PLOTLINE_COLOR};
    }

    &:not(.end):hover {
      /* NOTE: Linaria don't like var interpolation inside rule value. 
      We need to extract it into selector scoped variable. */
      --color: ${color.hydrogen};
      color: var(--color) !important;
      border-color: ${color.lightNitrogen500_Main};
      background-color: ${color.lightNitrogen500_Main};
      width: auto !important;
      z-index: ${PlotlineLabelZIndex.cycleHover};
    }
  }
`;

export default Wrapper;
